<ion-header class="extendido" *ngIf="loaded">
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-buttons>
          <ion-button (click)="closeModal()">
            <i class="fa-regular fa-chevron-left chevron-back-button"></i>
          </ion-button>
          <ion-title class="ion-title-icon">{{'Detalhe da Notificação' | translate}}</ion-title>
        </ion-buttons>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>
  <ion-card *ngIf="detalhes.id">
    <ion-row>
      <ion-col>
        <h2 class="bold-1">{{detalhes.title}}</h2>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <p>{{detalhes.dataEnvio | dateFormat:'dataHora' }}</p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <p [innerHTML]="detalhes.message | safeHtml: 'html'"></p>
      </ion-col>
    </ion-row>    
  </ion-card>
</ion-content>
